import { INVALIDATE_TRANSACTIONS } from 'actions/invalidationTags';
import { ApiMananger } from 'actions/rtkquery';
import {
  GET_ALL_TRANSACTIONS_API_ROUTE,
  GET_ONE_TRANSACTIONS_API_ROUTE,
} from 'routes/api/endpoints';

const transactionApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getTransactions: build.query({
      query: ({ dossier_id }) =>
        `${GET_ALL_TRANSACTIONS_API_ROUTE}${dossier_id}/`,
      providesTags: [INVALIDATE_TRANSACTIONS],
    }),

    getTransactionId: build.query({
      query: ({ dossier_id, type, id }) =>
        `${GET_ONE_TRANSACTIONS_API_ROUTE}${dossier_id}/${type}/${id}/`,
      providesTags: [INVALIDATE_TRANSACTIONS],
    }),
  }),
  overrideExisting: false,
});

export const { useGetTransactionsQuery, useGetTransactionIdQuery } =
  transactionApi;
